import React, { useEffect, useRef, useState } from "react";
import {
  FiCheck,
  FiChevronLeft,
  FiChevronRight,
  FiEdit2,
  FiPlus,
} from "react-icons/fi";
import FormModal from "../FormModal";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { formatLabel } from "../../actions/payments";
import { handleValidationError } from "../../actions/validation";
import BusinessKycStepper from "./Compliance/BusinessKyb";
import IndividualKyc from "./Compliance/IndividualKyc";


const Compliance = ({ userDetails }) => {
  const dispatch = useDispatch();
  return (
    <section className="bankInfo-content container">
      {userDetails?.account_type === "business" ? <div className="row">
        <div className="p-4 pt-0 rounded shadow-sm">
          <BusinessKycStepper userDetails={userDetails} />
        </div>
      </div> : <IndividualKyc userDetails={userDetails}/>}
    </section>
  );
}

export default Compliance;
